import Page from '@/components/Page/Page';
import AddVariableContractLinesContainer from './AddVariableContractLines.container';

export default function AddVariableContractLines(): JSX.Element {
  return (
    <Page
      padding={true}
      pageTitle="Add Contract Line"
    >
      <AddVariableContractLinesContainer />
    </Page>
  );
}
